import { min } from 'lodash';
import * as React from 'react';

interface DerivateHeaderProps {
    derivates: Map<number, string>;
    derivateToColorMap: { [key: string]: string };
    isBasicMarketLoaded: boolean;
}

// Style for each derivate header cell
const derivateHeaderStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px 0px',
    width: 50,
    height: 150,
    flexGrow: 1,
    flexBasis: '50px',
    textAlign: 'center',
    writingMode: 'vertical-rl',
    transform: 'rotate(180deg)',
    fontSize: '0.8em',
    borderLeft: '1px solid rgba(34,36,38,.1)',
    textWrap: 'auto',
} as any;

const DerivateHeader = React.memo((props: DerivateHeaderProps) => {
    // Cache the derivates array for performance
    const derivatesArr = props.derivates ? Array.from(props.derivates) : [];

    return (
        <div style={{ display: 'flex', width: '100%', boxSizing: 'border-box', margin: 0, padding: 0 }}>
            {derivatesArr.map((item, index) => {
                // item[0] is the key, item[1] is the value
                const color = props.derivateToColorMap[item[0]] ? props.derivateToColorMap[item[0]] + "90" : "unset";
                return (
                    <div
                        key={"der" + index}
                        style={{
                            ...derivateHeaderStyle,
                            background: color,
                        }}
                    >
                        {item && item.length > 0 ? item[1] : item}
                    </div>
                );
            })}
        </div>
    );
});

export default DerivateHeader;



// WEBPACK FOOTER //
// ./src/components/Table/components/headerComponents/DerivateHeader.tsx